<template>
    <v-container class="h-100 dictionary-page" >
      <v-card
              class="card-container">
        <v-card-title v-if="false">
          <v-row no-gutters>
            <v-col>
              <span class="subheader-label">Последнее изменение:</span> <span class="subheader-strong-label">{{lastEdit}}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <span class="selling-label"></span>Продано <span class="selling-count">{{1228}}</span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text
                class="h-100"  style="overflow-y: hidden">
          <v-container fluid class="h-100">
          <div class="header-lables">
            <div class="header-bonus-label">Бонусы</div>
            <div class="header-standart-label">Лайт</div>
            <div class="header-silver-label">Страховой +</div>
            <div class="header-gold-label">Комфорт</div>
          </div>
            <div class="bonuses-container">
              <div class="bonus-item" v-for="item in bonusItems">
                <div class="bonus-item_wrapper">
                  <div class="bonus-item_name">{{item.partnerTypeName}} ({{item.bonusName}})</div>
                  <div class="bonus-item_count">{{item.countA}}</div>
                  <div class="bonus-item_count">{{item.countB}}</div>
                  <div class="bonus-item_count">{{item.countC}}</div>
                </div>
                <div v-if="canEdit" class="bonus-item_action">
                  <v-btn @click="showEditModal(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
                </div>
              </div>
            </div>
            <v-btn v-if="canEdit"
                    dark
                    dense
                    color="var(--color-blue)"
                    @click="showAddBonusModal"
            >
              <span class="btn-text"> <v-icon dark>add</v-icon> Добавить бонус</span>
            </v-btn>

          </v-container>

        </v-card-text>
      </v-card>

      <b-modal
              id="modalAddBonus"
              centered
              title="Добавление бонуса"
      >
        <b-container fluid>
          <b-row class="mb-1">
            <b-col>
              <label class="custom-group-label">Категория</label>
              <b-select
                    :options="partnerTypes"
                    v-model="editedItem.partnerTypeId"
                    value-field="id"
                    text-field="partnerTypeName"

            />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-group-label">Наименование</label>
              <b-input
                      v-model="editedItem.bonusName"

              />
            </b-col>
          </b-row>
          <div class="mb-2">
            <label class="custom-group-label">Количество в пакетах</label>
          </div>


          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Лайт</label>
              <b-input
                      v-model="editedItem.countA"
                      type="number"


              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Страховой +</label>
              <b-input
                      type="number"
                      v-model="editedItem.countB"

              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Комфорт</label>
              <b-input
                      type="number"
                      v-model="editedItem.countC"

              />
            </b-col>
          </b-row>
        </b-container>
        <template slot="modal-footer">
          <div class="w-100">
            <v-row no-gutters  justify="space-between">

              <v-spacer></v-spacer>
              <v-col cols="auto" class="mr-2">
                <v-btn
                        color="var(--color-blue)"
                        dark
                        size="sm"
                        @click="onSave"
                >
                  Сохранить
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                        class="cancel-btn"
                        outlined
                        color="var(--color-3)"
                        size="sm"
                        @click="$bvModal.hide('modalAddBonus')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </template>
      </b-modal>

      <b-modal
              id="modalEditBonus"
              centered
              title="Редактирование бонуса"
      >
        <b-container fluid>
          <b-row class="mb-1">
            <b-col>
              <label class="custom-group-label">Категория</label>
              <b-select
                      :options="partnerTypes"
                      v-model="editedItem.partnerTypeId"
                      value-field="id"
                      text-field="partnerTypeName"

              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-group-label">Наименование</label>
              <b-input
                      v-model="editedItem.bonusName"

              />
            </b-col>
          </b-row>
          <div class="mb-2">
            <label class="custom-group-label">Количество в пакетах</label>
          </div>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Лайт</label>
              <b-input
                      v-model="editedItem.countA"
                      type="number"

              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Страховой +</label>
              <b-input
                      v-model="editedItem.countB"
                      type="number"

              />
            </b-col>
          </b-row>
          <b-row no-gutters class="mb-2">
            <b-col>
              <label class="custom-input-label">Комфорт</label>
              <b-input
                      v-model="editedItem.countC"
                      type="number"

              />
            </b-col>
          </b-row>

        </b-container>
        <template slot="modal-footer">
          <div class="w-100">
            <v-row no-gutters  justify="space-between">
              <v-col cols="auto">
                <v-btn
                        outlined
                        color="var(--color-red)"
                        size="sm"
                        @click="deleteItem"
                >
                  <v-icon>mdi-delete</v-icon> Удалить
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="mr-2">
                <v-btn
                        color="var(--color-blue)"
                        dark
                        size="sm"
                        @click="onSave"
                >
                  Сохранить
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                        class="cancel-btn"
                        outlined
                        color="var(--color-3)"
                        size="sm"
                        @click="$bvModal.hide('modalEditBonus')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </template>
      </b-modal>

    </v-container>

</template>

<script>
    export default {
      name: "Bonuses",
      data(){
        return {
            editedItem:{
                id:null,
                partnerTypeId: null,
                bonusName: null,
                countA: 0,
                countB: 0,
                countC: 0,
            },
        }
      },
        created() {
            this.$store.dispatch("Bonuses/loadBonuses").catch(err => {
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки бонусных пакетов!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })
            this.$store.dispatch("Bonuses/loadPartnerTypes").catch(err => {
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки типов партнеров!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })

        },
        computed:{
          bonusItems(){
              return this.$store.state.Bonuses.bonuses

          },

            lastEdit(){
              let dt=new Date()
                return dt.toLocaleString()
            },

            partnerTypes(){
                return this.$store.state.Bonuses.partnerTypes
            },

            canEdit(){
              let curUser=this.$store.state.userData.webUser
              if(curUser!=null){
                  if(curUser.webUserAccessLevelCode=="SYS")
                      return true
                  else return false
              }
              else return false
            }
        },
        methods:{
            showEditModal(item){
                for (let key in this.editedItem){
                    if(item[key]){
                        this.editedItem[key]=item[key]
                    }
                }
                this.$bvModal.show('modalEditBonus')
            },

            showAddBonusModal(){
                for (let key in this.editedItem){
                    this.editedItem[key]=null
                }
                this.$bvModal.show('modalAddBonus')
            },

            onSave(){
                const vm=this;
                //если есть id, то редактируем запись, иначе добавляем
                if(this.editedItem.id!=null){
                    try {
                        this.$store.dispatch('Bonuses/editBonus', this.editedItem).then(()=> {
                                this.$bvToast.toast("Бонус успешно обновлен", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }
                        ).catch(err=>{
                            this.$bvToast.toast(err.message, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    }catch(e){
                        console.log(e)
                    }
                    this.$bvModal.hide('modalEditBonus')
                }
                else{
                    try {
                        this.$store.dispatch('Bonuses/addBonus', this.editedItem).then(()=>{
                            this.$bvToast.toast("Бонус успешно добавлен",{
                                variant: "success",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        }).catch(err=>{
                            this.$bvToast.toast(err.message, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    }catch(e){
                        console.log(e)
                    }
                    this.$bvModal.hide('modalAddBonus')
                }
            },

            deleteItem(id) {
                const vm=this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if(value==true){
                            this.$store.dispatch('Bonuses/deleteBonus', id).then(()=>{
                                this.$bvToast.toast("Бонус успешно добавлен",{
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }).catch(err=>{
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        }

                    })
                    .catch(err => {

                    })
            },

        }

    }
</script>

<style scoped>

  .selling-label{
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color:black;
  }
  .selling-count{
    font-weight: 600;
    font-size: 24px;
    line-height: 40px;
    color:black;
  }

  .header-lables{
    display: flex;
    flex-direction: row;
    width: 70%;
    min-width: 350px;
    padding: 5px 15px;
  }

  .header-bonus-label{
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    color:black;
    width: 35%;
    min-width: 120px;

  }

  .header-standart-label{
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    color:#327BC6;
    width: 20%;
    min-width: 60px;
    text-align: center;
  }

  .header-silver-label{
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    color:#9DA5C5;
    width: 20%;
    min-width: 60px;
    text-align: center;
  }

  .header-gold-label{
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    color:#CEA924;
    width: 20%;
    min-width: 60px;
    text-align: center;
  }
  
  .bonuses-container{
    width: 70%;
    padding-bottom: 20px;
    overflow-y: scroll;
    height: 100%;
  }
  
  .bonus-item{
    margin: 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;

  }
  
  .bonus-item_wrapper{
    width: 95%;
    background-color: #FAFAFA;
    padding: 10px 15px;
    display: flex;
    flex-direction: row;
  }
  .bonus-item_name{
    width: calc((105% + 10px) * 0.35);
    min-width: 120px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color:black;
  }
  .bonus-item_count{
    width: calc((105% + 10px) * 0.20);
    min-width: 60px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color:black;

  }  
  .bonus-item_action{
    background-color: #FAFAFA;
    margin-left: 10px;
    padding: 2px;
  }

  @media (max-width: 1195px){
    .header-lables, .bonuses-container{
      width: 100% !important;
    }

  }
  @media (max-width: 992px){
    .header-standart-label, .header-silver-label, .header-gold-label{
      font-size: 15px;
    }
  }



</style>
